<template>
  <div class="success-page">
    <div class="success-content">
      <div class="hand-icon">
        <img src="@/assets/images/content/successRegister.svg" width="140px" alt="successRegister" />
      </div>
      <div v-if="isLoading">
         <h1>{{ $t('legacy.Проверка...') }}</h1>
         <p>{{ $t('Подождите, мы проверяем вашу почту') }}</p>
      </div>
      <div v-else-if="emailVerificationSuccess">
         <h1>{{ $t('legacy.Почта подтверждена') }}</h1>
         <p>{{ $t('legacy.Можете переходить к созданию дизайна оформления') }}</p>
         <button @click="redirectToDesign" class="create-design-btn">{{ $t('legacy.СОЗДАТЬ ДИЗАЙН') }}</button>
      </div>
      <div v-else>
         <h1>{{ $t('Ошибка верификации') }}</h1>
         <p>{{ errorMessage || $t('Не удалось подтвердить почту. Возможно, ссылка истекла или уже была использована.') }}</p>
          <button @click="redirectToLogin" class="create-design-btn">{{ $t('legacy.ВОЙТИ') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import eyeIcon from '@/assets/images/auth/eye_icon.svg';
import eyeIconOff from '@/assets/images/auth/eye_icon_off.svg';
import { localizedAuthPath } from '@/utils/authRoutes';

export default {
  data() {
    return {
      form: {
        token: this.$route.query.token,
      },
      fieldErrors: {}, // Ошибки по каждому полю
      errorMessage: "",
      successMessage: "",
      showPassword: false,
      isLoading: true,
      eyeIcon,
      eyeIconOff
    };
  },
  computed: {
    ...mapState("auth", ["emailVerificationSuccess"]),
  },
  methods: {
    ...mapActions("auth", ["emailVerification"]),

    async handleEmailVerification() {
      this.fieldErrors = {};
      this.errorMessage = "";
      this.isLoading = true;
      try {
        const response = await this.emailVerification(this.form);
        if (response && response.errors) {
          const detail = response.errors.details?.general?.[0]
            || (Array.isArray(response.errors.details) ? response.errors.details[0] : '');
          this.errorMessage = this.$t(response.errors.title || detail || 'Ошибка верификации');
        }
      } catch (error) {
         const errors = error.response?.data?.errors || {};
         const detail = errors.details?.general?.[0]
           || (Array.isArray(errors.details) ? errors.details[0] : '');
         this.errorMessage = this.$t(
           errors.title || detail || 'Произошла ошибка при верификации. Попробуйте еще раз.'
         );
      } finally {
        this.isLoading = false;
      }
    },
    redirectToDesign() {
      this.$router.push('/projects')
    },
    redirectToLogin() {
      this.$router.push(localizedAuthPath(this.$route, '/login'))
    },
  },
  async created() {
    await this.handleEmailVerification();
  },
};
</script>


<style scoped>
/* Импорт шрифта Montserrat */
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap');

.success-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(to bottom, #fafafa 0%, #bfcadf 70%);
  font-family: 'Montserrat', Arial, sans-serif;
}

.success-content {
  text-align: center;
  max-width: 400px;
  padding: 40px 20px;
  border-radius: 10px;
}

.hand-icon {
  font-size: 96px;
  margin-bottom: 20px;
}

h1 {
  color: #2f3a4a;
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 28px;
}

p {
  color: #556877;
  font-size: 16px;
  margin-bottom: 30px;
  line-height: 1.4;
}

.create-design-btn {
  width: 100%;
  padding: 14px;
  font-size: 16px;
  background-color: #496782;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  box-shadow: -5px -3px 8px 0px #FFFFFF;
}
</style>
